let uploadFiles = [];

(function () {
    loadDropzone()
})();

function loadDropzone() {
    uploadFiles = $('#fileDropZone').data('files')
        .filter(file => file.type === 'upload')
        .map(file => Object.assign({ status: 'success' }, file));

    const dropzone = new Dropzone(
        "div#fileDropZone",
        {
            url: "/file",
            acceptedFiles: 'image/jpeg,image/png,image/webp,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            parallelUploads: 1,
            disablePreviews: true
        }
    );

    $('#uploadButton').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        dropzone.hiddenFileInput.click()
    })

    dropzone.on("sending", (file, xhr, formData) => {
        formData.append("id", file.upload.uuid);
        uploadFiles.push({ name: file.name, id: file.upload.uuid, status: 'pending' })
        scrollToFiles();
        reloadFiles();
    });

    dropzone.on("complete", function (completedFile, response) {
        const fileIndex = uploadFiles.findIndex(file => file.id === completedFile.upload.uuid);
        const file = uploadFiles[fileIndex];
        if (completedFile.status !== 'error') {
            file.status = 'success';
        };

        reloadFiles();
    });

    dropzone.on("error", function (errorFile, response) {
        const fileIndex = uploadFiles.findIndex(file => file.id === errorFile.upload.uuid)
        if (fileIndex !== -1) uploadFiles.splice(fileIndex, 1);
        addError(response.message);
    });

    function reloadFiles() {
        handleReloadFiles()
    }

    function addError(message) {
        const $error = $('<div />').addClass('alert').addClass('alert-danger').addClass('my-2').addClass('d-inline-block').addClass('w-100');
        if (!message || message.length === 0) {
            if ($('.process-import-container .process-file-upload').data("errormessage")) {
                message = $('.process-import-container .process-file-upload').data("errormessage")
            } else {
                message = "Une erreur est survenue, ce fichier n'est pas supporté."
            }
        }
        $error.append(message)
        $error.append('<button type="button" class="close" data-dismiss="alert" aria-label="Close" ><span aria-hidden="true">&times;</span></button>')
        $('.process-import-container .process-file-upload').prepend($error)
        $('.process-import-container .process-file-upload').addClass("with-error")
    }

    reloadFiles();
}

function getFiles() {
    return uploadFiles;
}

function scrollToFiles() {
    if ($('.process-file-upload').length > 0) {
        if ($('.page-letter-write').length > 0){
            $('html, body').animate({
                scrollTop: $('.page-letter-write .scroll-buttons-container').offset().top - 100
            }, 'smooth');
        } else if ($('.ownLetter-home').length > 0){
            $('html, body').animate({
                scrollTop: $('.ownLetter-home .ck-editor').offset().top
            }, 'smooth');
        } else {
            $('html, body').animate({
                scrollTop: $('#fileDropZone').offset().top - 30
            }, 'smooth');
        }
    }
}

function removeFile(removedFile) {

    fetch(`/file/${removedFile.id}/delete`)

    const fileIndex = uploadFiles.findIndex(file => file.id === removedFile.id);
    if (fileIndex !== -1) uploadFiles.splice(fileIndex, 1);

    handleReloadFiles();
}

function handleReloadFiles() {
    const uploadEvent = new CustomEvent("upload-reload", {
        detail: { files: uploadFiles },
        bubbles: true,
        cancelable: true,
        composed: false,
    });
    document.dispatchEvent(uploadEvent);

    const filesToDisplay = getFiles()

    if ($('.process-file-upload-count').length > 0) $('.process-file-upload-count').text(filesToDisplay.length);

    const $filesContainer = $('.process-file-upload .process-file-upload-files');
    $filesContainer.html('');

    filesToDisplay.forEach(file => {
        const $element = $('<div />').addClass('alert').addClass('alert-primary').addClass('my-1').addClass('d-inline-block').addClass('w-100');
        $element.append(file.name)
        if (file.status !== 'success') {
            $element.append($('<div class="spinner-border float-right" role="status" />'))
        } else {
            const $close = $('<button type="button" class="close" ><span aria-hidden="true">&times;</span></button>')
            $close.on('click', () => removeFile(file))
            $element.append($close)
        }


        if ($('.clonable-element').length > 0) {
            var clone = $(".clonable-element").find(".uploaded-element").clone()

            let splittedName = file.name.split(".")
            let shortName;
            if (splittedName[splittedName.length - 1].length > 5) {
                shortName = `${file.name.slice(0, 10)}${file.name.length > 10 ? "[...]" : ""}.pdf`
            } else {
                let extension = splittedName.pop()
                let fileNoExtension = splittedName.join(".")
                shortName = `${fileNoExtension.slice(0, 10)}${fileNoExtension.length > 10 ? "[...]" : ""}.${extension}`
            }
            if (file.status !== 'success') {
                $(clone).find(".folder-icon").hide();
                $(clone).find(".spinner-border").show();
            }
            $(clone).find(".uploaded-element-name span").text(shortName)
            $(clone).find(".more-info").on('click', function () {
                $(".more-info-container").removeClass("active")
                $(this).parent().find(".more-info-container").addClass("active")
            })
            $(clone).find(".delete-file-element").on('click', () => removeFile(file))

            $filesContainer.append(clone)
        } else {
            $filesContainer.append($element)
        }
    })
}

//UPLOAD CUSTOM LINK
$(".custom-url-import").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(".custom-url-input").show();
    $(".changeable-size-button").addClass("bigger")
    $("#customUrlInput").focus();
})
$(".custom-url-input").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
})
$("#customUrlInput").on("keypress", function (e) { //let send it via pressing enter
    if (e.which === 13) {
        uploadCustomUrl();
        return false;
    }
})
$("#customUrlSubmit").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    uploadCustomUrl();
})

async function uploadCustomUrl() {
    const url = $("#customUrlInput").val()
    const pattern = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
    const regex = new RegExp(pattern);
    if (url.length < 4 || !url.match(regex)) return;
    $(".custom-url-error").hide();
    $(".changeable-size-button").removeClass("with-error")
    $(".custom-url-import .upload-spinner").show()
    $(".custom-url-import .logo").hide()
    const response = await fetch('/file/custom-url', {
        method: 'POST',
        body: JSON.stringify({ url: $("#customUrlInput").val() }),
        headers: {
            'Content-Type': 'application/json'
        }
    });
    const jsonResponse = await response.json();

    if (jsonResponse.fileDone) {
        jsonResponse.files.forEach(resFile => {
            uploadFiles.push({ name: resFile.name, id: resFile.id, status: 'success' })
        })
        $("#customUrlInput").val("")
        handleReloadFiles();
    } else {
        $(".custom-url-error").show();
        $(".changeable-size-button").addClass("with-error")
    }
    $(".custom-url-import .upload-spinner").hide()
    $(".custom-url-import .logo").show()
}